require('../../modules/es6.number.parse-int');
module.exports = parseInt;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/parse-int.js
// module id = 588
// module chunks = 0